import { createHandlerChainRunner } from "@insite/client-framework/HandlerCreator";
import { CustomApiHandler } from "@WhiteCap/Store/CustomHandlerCreator/CustomHandlerCreator";

type HandlerType = CustomApiHandler<{ quoteCount: number }, { quoteCount: number }>;

export const BeginLoadQuoteCount: HandlerType = props => {
    props.dispatch({
        type: "Custom/Quote/BeginLoadQuoteCount",
    });
};

export const CompletedLoadQuoteCount: HandlerType = props => {
    const { quoteCount } = props.parameter;
    const state = props.getState();
    const prevQuoteCount = state.WhiteCap?.quoteCart?.quoteCount;

    if (quoteCount === undefined || quoteCount === null) {
        return;
    }

    if (prevQuoteCount === quoteCount) {
        return;
    }

    if (prevQuoteCount > 0 && quoteCount === 0) {
        return;
    }

    props.dispatch({
        type: "Custom/Quote/CompletedLoadQuoteCount",
        quoteCount,
    });
};

export const chain = [BeginLoadQuoteCount, CompletedLoadQuoteCount];

const quoteCountHandler = createHandlerChainRunner(chain, "quoteCountHandler");
export default quoteCountHandler;
